export enum EnumPermissions {
  // Dashboard
  DashboardViewAll = 'dashboard.viewall',
  DashboardViewRegion = 'dashboard.viewregion',
  DashboardViewDistrict = 'dashboard.viewdistrict',

  // Permission
  PermissionGetAll = 'permissions.getall',

  // Appellation
  AppellationGet = 'appellations.get',
  AppellationCreate = 'appellations.create',
  AppellationUpdate = 'appellations.update',
  AppellationDelete = 'appellations.delete',

  // Identity - User
  UserCreate = 'users.create',
  UserUpdate = 'users.update',
  UserDelete = 'users.delete',
  UserGet = 'users.get',
  UserInActive = 'users.inactive',

  // Identity - Role
  RoleCreate = 'roles.create',
  RoleUpdate = 'roles.update',
  RoleDelete = 'roles.delete',
  RoleGet = 'roles.get',
  RoleInActive = 'roles.inactive',

  // SP (Specialist)
  SPCreate = 'sp.create',
  SPUpdate = 'sp.update',
  SPDelete = 'sp.delete',
  SPGet = 'sp.get',

  // Organization
  InstitutionCreate = 'institutions.create',
  InstitutionUpdate = 'institutions.update',
  InstitutionDelete = 'institutions.delete',
  InstitutionGet = 'institutions.get',

  // Application
  ApplicationViewAll = 'applications.viewall',
  ApplicationViewRegion = 'applications.viewregion',
  ApplicationViewDistrict = 'applications.viewdistrict',
  ApplicationViewOrganization = 'applications.vieworganization',
  ApplicationApproveReject = 'applications.approvereject',
  ApplicationCreateSend = 'applications.createsend',
  ApplicationCancel = 'applications.cancel',
  ApplicationChangeStatus = 'applications.changestatus',

  // Invitation
  InvitationCreate = 'invitations.create',
  InvitationUpdate = 'invitations.update',
  InvitationDelete = 'invitations.delete',
  InvitationGet = 'invitations.get',
  InstitutionViewDistrict = 'institutions.viewdistrict',

  // Achievements
  AchievmentCreate = 'achievements.create',
  AchievmentUpdate = 'achievements.update',
  AchievmentDelete = 'achievements.delete',
  AchievmentGet = 'achievements.get',

  // Judge
  JudgeCreate = 'judges.create',
  JudgeUpdate = 'judges.update',
  JudgeDelete = 'judges.delete',
  JudgeGet = 'judges.get',

  // Olympiad
  OlympiadCreate = 'olympiads.create',
  OlympiadUpdate = 'olympiads.update',
  OlympiadDelete = 'olympiads.delete',
  OlympiadGet = 'olympiads.get',

  // Stage
  StageCreate = 'stages.create',
  StageUpdate = 'stages.update',
  StageDelete = 'stages.delete',
  StageGet = 'stages.get',
  StageAssignWinnersToNextStage = 'stages.assignwinnerstonextstage',

  // Expert
  ExpertCreate = 'experts.create',
  ExpertUpdate = 'experts.update',
  ExpertDelete = 'experts.delete',
  ExpertGet = 'experts.get',

  // Variant
  VariantCreate = 'variants.create',
  VariantUpdate = 'variants.update',
  VariantDelete = 'variants.delete',
  VariantGet = 'variants.get',
  VariantApproveReject = 'variants.approvereject',

  // Director
  DirectorCreate = 'directors.create',
  DirectorGet = 'directors.get',
  DirectorViewRegion = 'directors.viewregion',
  DirectorViewDistrict = 'directors.viewdistrict',
  DirectorViewOrganization = 'directors.vieworganization',

  // Participant
  ParticipantCreate = 'participants.create',
  ParticipantGet = 'participants.get',
  ParticipantViewRegion = 'participants.viewregion',
  ParticipantViewDistrict = 'participants.viewdistrict',
  ParticipantViewOrganization = 'participants.vieworganization',

  // AUDTORIYA RAHBARI
  ParticipantDisqualified = 'participants.disqualified',

  // Exam
  ExamCreate = 'exam.create',
  ExamUpdate = 'exam.update',
  ExamDelete = 'exam.delete',
  ExamGet = 'exam.get',
  ExamSeatingAssignRegionalStage = 'examseating.assignregionalstage',
  ExamSeatingAssignDistrictStage = 'examseating.assigndistrictstage',

  // Stage Result
  StageResultDelete = 'stageresult.delete',
  StageResultUpdate = 'stageresult.update',
  StageResultCreate = 'stageresult.create',
  StageResultGet = 'stageresult.get',
  StageResultViewAll = 'stageresult.viewall',
  StageResultViewRegion = 'stageresult.viewregion',
  StageResultViewDistrict = 'stageresult.viewdistrict',

  // AnswerSheet / OMR (backend numeric permission IDs)
  OmrView = '105',
  OmrCheck = '106',
  AnswerSheetUpload = '107',
  AnswerSheetGenerate = '108',
  SumbitAnswerSheetJudge = '109',
  AnswerSheetDownload = '120',
  // NOTE: backend uses 121 for judge-checking; keep single enum member to avoid duplicates
  // CheckingJudge = '121',

  // Legacy/other OMR CRUD codes (kept as-is if backend still uses codes)
  OmrCreate = 'omr.create',
  OmrUpdate = 'omr.update',
  OmrDelete = 'omr.delete',
  OmrGet = 'omr.get',

  // Checking Expert (kept for backwards compatibility in UI code)
  CheckingExpert = 'answersheet.checkingjudge',

  // Group Permissions (Robo Coding jamoaviy arizalar)
  GroupPermissionsValidate = 'grouppermissions.validate',
  GroupPermissionsViewAll = 'grouppermissions.viewall',
  GroupPermissionsViewRegion = 'grouppermissions.viewregion',
  GroupPermissionsViewDistrict = 'grouppermissions.viewdistrict',
  GroupPermissionsViewOrganization = 'grouppermissions.vieworganization',

  // Advanced Engineering jamoaviy arizalar (Ilg'or muhandislik)
  AdvancedEngineeringOlympiadGet = 'advancedengineeringolympiad.get',
  AdvancedEngineeringOlympiadTeamCreate = 'advancedengineeringolympiad.teamcreate',

  // Step to Invention loyiha arizalari (menyu ruxsatlari)
  StepToInventionProjectAdminMenu = 'menuAdmin.applications_menu.step_to_invention_project',
  StepToInventionProjectUserMenu = 'menuUser.step_to_invention_project',

  // Winner (backend uses singular "winner.*" permission codes)
  WinnerGet = 'winner.get',
  WinnerCreate = 'winner.create',

  // Resources (olympiad materials)
  ResourceGet = 'resouce.get',
  ResourceCreate = 'resouce.create',
  ResourceUpdate = 'resouce.update',
  ResourceDelete = 'resouce.delete',

  // International Science Olympiad
  InternationalScienceOlympiadGetAllStudents = 'internationalscienceolympiad.getallstudents',

  // Demo Test
  DemoTestView = 'demotest.view',
}
